// src/utils/format.ts
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

// Parsear fecha forzando hora local (no UTC)
const parseDate = (date: string | Date): Date => {
  if (date instanceof Date) return date;
  // Si viene YYYY-MM-DD (solo fecha)
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return new Date(date + 'T00:00:00');
  }
  // Si viene YYYY-MM-DD HH:mm:ss (fecha + hora sin T ni Z)
  // Reemplazar espacio por T para que JS lo interprete como local
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date)) {
    return new Date(date.replace(' ', 'T'));
  }
  // Si viene con T pero sin Z, ya es local
  // Si viene con Z o +offset, es UTC (dejarlo como está)
  return new Date(date);
};

export const formatDate = (date: string | Date): string => {
  return format(parseDate(date), 'dd/MM/yyyy HH:mm', { locale: es });
};

export const formatMoney = (amount: number): string => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatDateOnly = (date: string | Date): string => {
  return format(parseDate(date), 'dd/MM/yyyy', { locale: es });
};